import React from "react"
import Navbar from "../../../Common/Components/Navbar"
import Footer from "../../../Common/Components/Footer"
import Sidebar from "../../../Sidebar/Sidebar"
import ViewItemComp  from "./Component/ViewItemComp"

const ViewItem =()=>{
    return(
        <>
        <Navbar />
        <div className="d-flex mainContentArea">
            <Sidebar />
            <ViewItemComp />
        </div>
        <Footer />
        </>
    )
}

export default ViewItem